import customCss from '@/app/components/hotel-detail/css/customCss';
import RoomPanelDesktopHeader from '@/app/components/hotel-detail/rooms/RoomPanelDesktopHeader';
import {
  MealPlanOptionsByMealPlan,
  VerticalSeparator,
} from '@/app/components/hotel-detail/rooms/RoomPanelMealPlanOptions';
import { css } from 'styled-components';

type RoomPanelDesktopProps = {
  room: RoomType;
  noRoomImages: boolean;
  selectedMealPlan: MealPlanType;
  onContinueClick: (mealPlan: MealPlanType) => void;
  onSelectMealPlan: (mealPlan: MealPlanType) => void;
};

export function RoomPanelDesktop(props: RoomPanelDesktopProps) {
  const { room, noRoomImages, selectedMealPlan, onContinueClick, onSelectMealPlan } = props;

  return (
    <div
      css={`
        display: flex;
        flex-direction: row;
        padding: 24px;
        border-radius: 8px;
        background-color: white;
      `}
    >
      <RoomPanelDesktopHeader
        room={room}
        noRoomImages={noRoomImages}
        selectedMealPlan={selectedMealPlan}
        onSelectMealPlan={onSelectMealPlan}
      />
      <VerticalSeparator />
      <div
        css={css`
          background-color: ${(p) => p.theme.kallisto.color.background.static.backgroundLayer02};
          display: flex;
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;

          flex: 1;
          flex-direction: column;

          @media ${customCss.breakpoints.xl} {
            width: 100%;
            min-width: 0;
          }
        `}
      >
        <MealPlanOptionsByMealPlan
          context="room-panel"
          room={room}
          selectedMealPlan={selectedMealPlan}
          variation="two-columns"
          onContinueClick={onContinueClick}
          onSelectMealPlan={onSelectMealPlan}
        />
      </div>
    </div>
  );
}
